module.exports = __webpack_public_path__ + "static/email-template-password-reset-d8858b0502e638582f0305e33f94f8e8.png";